import { changeCustomerBillToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";
import { css } from "styled-components";

changeCustomerBillToSelectorStyles.billToSelectorDynamicDropdown = {
    iconProps: {
        css: css`
            top: 4px !important;
        `,
    },
};
